/*
  KIK free mystery hat (Early Black Friday, Nov 2 2026). Replaces the BOGOS app offer.
  The hat is its own $0 product (window.kwGift.variant, theme setting ebf_hat_variant), so no
  Shopify discount is involved and the 15% / 2nd pant deals are untouched.
  Rule: while the promo is live (html.kw-bmsm-live) and the bag holds at least one pant or short
  (product_type in kwGift.types, the hat itself excluded), the bag holds exactly 1 hat; otherwise
  none. Re-checked on page load and after every cart change (PUB_SUB cartUpdate).
  After a change it re-renders the drawer contents and the cart bubble WITHOUT opening the drawer
  (CartDrawer.renderContents would open it), then checks once more ~1.5 s later because the
  drawer's own refresh from the same cart event can land after ours with the hat missing.
  A failed add (e.g. the hat is not sold in this market) stops the engine for the session.
*/
(function () {
  var cfg = window.kwGift;
  if (!cfg || !cfg.variant) return;
  var HAT = Number(cfg.variant);
  var TYPES = (cfg.types || []).map(function (t) { return String(t).trim().toUpperCase(); });
  var busy = false;
  var again = false;
  var passes = 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function live() {
    return document.documentElement.classList.contains('kw-bmsm-live');
  }
  function stopped() {
    try { return sessionStorage.getItem('kwGiftStop') === '1'; } catch (e) { return false; }
  }
  function stop() {
    try { sessionStorage.setItem('kwGiftStop', '1'); } catch (e) {}
  }
  function qualifies(item) {
    return item.variant_id !== HAT && !item.gift_card && item.final_price > 0 &&
      TYPES.indexOf(String(item.product_type || '').trim().toUpperCase()) > -1;
  }
  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function paint(sections) {
    if (!sections) return;
    var drawer = typeof getActiveCartDrawer === 'function' ? getActiveCartDrawer() : document.querySelector('cart-drawer');
    var parse = function (html, sel) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
      return el ? el.innerHTML : null;
    };
    if (drawer && sections['cart-drawer']) {
      var target = document.querySelector('#CartDrawer-B');
      var inner = parse(sections['cart-drawer'], '#CartDrawer-B');
      if (target && inner != null) target.innerHTML = inner;
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && html != null) bubble.innerHTML = html;
    }
  }
  function drawerHasHat() {
    return !!document.querySelector('#CartDrawer-B [data-kw-gift-line]');
  }
  function refresh() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(paint);
  }
  function reconcile() {
    if (busy) { again = true; return; }
    if (stopped() || passes > 6) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = live() && cart.items.some(qualifies) ? 1 : 0;
        var hats = cart.items.filter(function (i) { return i.variant_id === HAT; });
        var have = hats.reduce(function (s, i) { return s + i.quantity; }, 0);
        if (have === want && (hats.length <= 1)) return null;
        passes++;
        var sections = 'cart-drawer,cart-icon-bubble';
        if (want === 1 && have === 0) {
          return post('cart/add.js', { items: [{ id: HAT, quantity: 1 }], sections: sections }).catch(function (e) {
            stop();
            throw e;
          });
        }
        // too many hats, a stray second line, or no pant left: keep the first line at `want`, clear the rest
        var chain = Promise.resolve();
        hats.forEach(function (line, i) {
          var q = i === 0 ? want : 0;
          if (line.quantity === q) return;
          chain = chain.then(function () { return post('cart/change.js', { id: line.key, quantity: q, sections: sections }); });
        });
        return chain;
      })
      .then(function (res) {
        if (!res) return;
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        paint(res.sections);
        setTimeout(function () {
          fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var inCart = c.items.some(function (i) { return i.variant_id === HAT; });
            if (inCart !== drawerHasHat()) refresh();
          });
        }, 1500);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; reconcile(); }
      });
  }
  function start() {
    reconcile();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(reconcile, 250); });
    }
    // the gate flips kw-bmsm-live on the shopper's clock; catch the start and the end of the window
    var was = live();
    new MutationObserver(function () {
      if (live() !== was) { was = live(); reconcile(); }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
